
export default {
  name: 'CategoryComponent',
  components: {},
  props: {
    cateType: {
      type: String,
      default: 'cateMain'
    },
    cateData: {
      type: [Array, Object],
      default: () => {
        return []
      }
    },
    /*
    active: {
      type: Number,
      default: 1
    },
    */
    quick: { // 23.08.14 퍼블 추가
      type: Boolean,
      default: false
    },
    brand: { // 23.08.14 퍼블 추가
      type: Boolean,
      default: false
    },
    tabType: {
      type: String,
      default: 'button'
    },
    isActive: {
      type: String,
      default: '1'
    },
    srchTxt: { // 검색
      type: String,
      default: ''
    },
    button: { // 스와이프 button type
      type: Boolean,
      default: false
    },
    /// 23.08.24 탭 타입 추가
    anchor: { // 스와이프 anchor type
      type: Boolean,
      default: false
    },
    /// 23.08.25 탭 타입 추가
    link: { // 스와이프 link type
      type: Boolean,
      default: false
    },
    radio: { // 스와이프 radio type
      type: Boolean,
      default: false
    },
    single: { // Panel X
      type: Boolean,
      default: false
    },
    giftCard: { // 상품권 탭 type
      type: Boolean,
      default: false
    },
    typeA: { // 탭 버튼 A type
      type: Boolean,
      default: false
    },
    typeB: { // 탭 버튼 A type
      type: Boolean,
      default: false
    },
    typeC: { // 탭 버튼 C type
      type: Boolean,
      default: false
    }
  },
  emits: ['select-category'],
  setup (_props, { emit }) {
    const fireSelectCategory = selectedCategoryId => emit('select-category', selectedCategoryId)

    return { fireSelectCategory }
  },
  data () {
    return {
      // faqCateSelect: { idx: 0 },
      cateSwiperOpt: {
        slidesPerView: 10,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        allowTouchMove: true // 23.08.14 퍼블 추가
      },
      naviShow: true,
      activeIdx: 0,
      // 이벤트 카테고리 data
      eventCate: [],
      // 대(메인)카테고리 data
      prodCate2: [],
      // 중카테고리 data
      prodCateMid: [],
      // 소카테고리 data
      prodCateSmall: [],
      // 링크 카테고리 data
      linkCate: [],
      // 퀵링크 카테고리 data
      // 23.08.14 퍼블 퀵링크 유형 추가
      quickLink: [],
      // 브랜드 링크 data
      // 23.08.14 퍼블 브랜드 유형 추가
      brandLink: [],
      ruleForm: {
        name: '' // textArea 글자
      },
      active: '2', // 탭 index(활성화)
      tabIndex: ['1'], // 아코디언 index
      swiperOpt: { // swiper options
        init: false,
        slidesPerView: 'auto',
        loop: false,
        lazy: true,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true, // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
        centeredSlides: false, // true시에 슬라이드가 가운데로 배치
        slideToClickedSlide: false // 해당 슬라이드 클릭시 슬라이드 위치로 이동
      }
    }
  },
  computed: {
    prodCate () {
      return [
        {
          title: '전체',
          link: '',
          exhCtgrNo: '',
          id: 0
        },
        ...this.cateData.map((item, i) => {
          return {
            id: i + 1,
            title: item.exhCtgrNm,
            link: '',
            exhCtgrNo: item.exhCtgrNo
          }
        }),
      ]
    }
  },
  watch: {
    // cateData () {
    //   this.slideWidth()
    // },
    isActive: {
      handler (value) {
        console.log('isActive', value)
        this.active = value
      }
    },
    active () {
      this.$emit('tabChanged', this.active)
    }
  },
  created () {
    console.log(' this.active', this.active, 'this.isActive', this.isActive)
    if (this.isActive !== undefined) {
      this.active = this.isActive
    }

    if (this.tabType === 'tabSwiper' && this.button === true && this.typeC === true) {
      this.swiperOpt.slidesPerGroup = 4
    }
  },
  mounted () {
    if (this.$refs.tabSwipe !== undefined) {
      this.$refs.tabSwipe.swiper.init()
    }
    // this.slideWidth()
  },
  methods: {
    activeOn (obj) {
      const index = this.prodCate.findIndex((item) => {
        return item.id === obj.id
      })
      this.active = String(index)

      this.$emit('fetchData', obj.exhCtgrNo)
      this.fireSelectCategory(obj.exhCtgrNo)

      const scrollArea = window
      scrollArea.scrollTo({ top: document.querySelector('.tab-wrap').offsetTop })
    },
    swiperBtnOn (e) {
      const index = this.prodCate.findIndex((item) => {
        return item.id === e.id
      })
      this.active = this.prodCate[index].id
    },
    slideWidth () { // slide 갯수에 따라 전체 넓이 체크 (필요시 호출)
      if (this.tabType === 'tabSwiper') {
        const swiperWidth = this.$refs.tabSwipe.$el.clientWidth
        const swiperItem = this.$refs.tabSwipe.$el.querySelectorAll('.swiper-slide')
        let widthSize = 0

        swiperItem.forEach((item) => {
          widthSize += item.clientWidth
        })

        if (widthSize < swiperWidth) {
          this.$refs.tabSwipe.$el.querySelector('.swiper-wrapper').classList.add('cont-center')
        } else {
          this.$refs.tabSwipe.$el.querySelector('.swiper-wrapper').classList.remove('cont-center')
        }
      }
    },
  }
}
